import { useMemo } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';
import useCanAccessOrgDashboard from './useCanAccessOrgDashboard';

const useOrgTypes = (kind) => {
  const { accountId } = useAccount();
  const canAccess = useCanAccessOrgDashboard();

  const storeKey = useMemo(() => ['orgTypes', accountId, kind], [accountId, kind]);

  const { isLoading, data } = useQuery(storeKey, () => api.fetchOrgTypes({ accountId, kind }), {
    enabled: !!accountId && !!kind && canAccess
  });

  const orgTypes = useMemo(() => data?.data || [], [data?.data]);
  const orgTypesOptions = useMemo(() => orgTypes.map(({ id, name }) => ({ value: id, label: name })), [orgTypes]);

  return { isLoading, orgTypes, orgTypesOptions };
};

export default useOrgTypes;
